module.exports = __webpack_public_path__ + "img/Car driver Icon - charcoal.6af0e160.svg";